import { switchStatusDepthConstants } from '../constants';

const statusDepth = (state, action) => {
    if (state === undefined) {
        return {
            switchStatusDepth: {},
            loading: false,
            error: null,
            success: false,
        };
    }

    switch (action.type) {
        case switchStatusDepthConstants.SWITCH_STATUS_DEPTH_REQUEST:
            return {
                switchStatusDepth: {},
                loading: true,
                error: null,
                success: false,
            };

        case switchStatusDepthConstants.SWITCH_STATUS_DEPTH_SUCCESS:
            return {
                switchStatusDepth: action.payload,
                loading: false,
                error: null,
                success: true,
            };

        case switchStatusDepthConstants.SWITCH_STATUS_DEPTH_FAILURE:
            return {
                switchStatusDepth: {},
                loading: false,
                error: action.payload,
                success: false,
            };

        default:
            return state;
    }
};

export default statusDepth;
